import React from "react";
import { Grid } from "@material-ui/core/";
import Aux from "../../../hoc/Auxilliary";
import Attedance from "../../../components/Faculty/Attendance";

const AttendancePage = (props) => {
  return (
    <Aux>
      <Grid container>
        <Grid item container xs={12} sm={10} style={{ margin: "0 auto" }}>
          <Attedance />
        </Grid>
      </Grid>
    </Aux>
  );
};

export default AttendancePage;
